import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import QuestionnaireList from './components/QuestionnaireList';
import QuestionnairePage from './components/QuestionnairePage';
import Question from '../common/models/Question';
import Questionnaire from '../common/models/Questionnaire';

app.initializers.add('tohsakarat-questionnaire', () => {
    app.store.models['qwn-questions'] = Question;
    app.store.models['qwn-questionnaires'] = Questionnaire;

    app.routes.questionnaires = { path: '/qwn-questionnaires', component: QuestionnaireList };
    app.routes.questionnairePage = { path: '/qwn-questionnaires/:id', component: QuestionnairePage };

    extend(IndexPage.prototype, 'navItems', function (items) {
        items.add(
            'questionnaires',
            <LinkButton icon="fas fa-clipboard-list" href={app.route('questionnaires')}>
                {app.translator.trans('tohsakarat-questionnaire.forum.list.title')}
            </LinkButton>,
            15
        );
    });
});
